module.exports = __webpack_public_path__ + "assets/img/36_679.5bd6fc59.jpg";